import { z } from 'zod';
import { BusinessStatus } from '../enums/BusinessStatus';

export enum InvoiceRange {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  BIWEEKLY = "BIWEEKLY",
  MONTHLY = "MONTHLY",
}

export interface BusinessApi {
  id: string;
  name: string;
  invoiceRange: InvoiceRange;
  lastInvoice: string | null;
  umBusinessId: string;
  status: BusinessStatus;
}

export interface Business {
  id: string;
  name: string;
  invoiceRange: InvoiceRange;
  lastInvoice: string | null;
  status: BusinessStatus;
}

export interface NewBusiness {
  name: string;
  invoiceRange: InvoiceRange;
}

export const businessSchema = z.object({
  name: z
    .string()
    .min(3, "Mínimo 5 caracteres")
    .max(100, "El nombre no puede tener más de 100 caracteres"),
  invoiceRange: z.nativeEnum(InvoiceRange),
});

export type BusinessSchema = z.infer<typeof businessSchema>;
